<template>
  <div class="dialog-wrap">
    <el-dialog
      title="题目选择"
      :close-on-click-modal="false"
      :visible.sync="dialogVisible"
      @close="handleClose"
      width="980px"
    >
      <el-form
        class="search-wrap"
        ref="searchForm"
        :inline="true"
        :model="query"
      >
        <el-form-item label="试卷" prop="paper">
          <el-select
            v-model="paper.id"
            filterable
            remote
            reserve-keyword
            placeholder="请输入关键词"
            :remote-method="fetchPaperList"
            @change="handlePaperChange"
            :loading="loading"
            style="width:360px;"
          >
            <el-option
              v-for="item in paperList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <el-table
        class="result"
        ref="multipleTable"
        :data="itemList"
        tooltip-effect="dark"
        size="mini"
        style="width: 100%"
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="55"> </el-table-column>
        <el-table-column prop="id" align="center" label="ID" width="100">
        </el-table-column>
        <el-table-column  label="题干" min-width="180">
          <template slot-scope="scope">
            <div class="material" v-if="scope.row.material">
              <span v-html="scope.row.rich_text"></span>
            </div>
            <div class="material" v-if="!scope.row.material">
              <span v-html="scope.row.description"></span>
            </div>
          </template>
        </el-table-column>
         <el-table-column label="题型" prop="answer_type_text" align="center" width="120" >
        </el-table-column>
         <el-table-column  label="题目ID" prop="item_id" align="center" width="120">
        </el-table-column>
        <el-table-column   label="在线状态" align="center" width="120">
          <template slot-scope="scope">
            <span v-if="scope.row.status===1">已上线</span>
            <span v-if="scope.row.status===0">已上线</span>
          </template>
        </el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary" @click="handleSubmit">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  examPaperList,
  examPaperItemUpdate,
  examPaperItemsUpdate,
  examPaperItemList,
  examPaperOne,
} from "@/api/exam";

export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      dialogVisible: this.visible,
      loading: false,
      query: {
        pageIndex: 1,
        pageSize: 10,
        isPaging: 1,
      },
      pageTotal: 10,
      filter: {
        status: [
          { label: "全部", value: "" },
          { label: "正常", value: "1" },
          { label: "下线", value: "0" },
        ],
        types: [
          { label: "全部", value: "" },
          { label: "统考", value: "1" },
          { label: "非统考", value: "0" },
        ],
      },
      paper: {},
      paperList: [],
      itemList: [],
      selections: [],
      countSelections: [],
    };
  },
  watch: {
    visible(val) {
      this.dialogVisible = val;
    },
  },
  methods: {
    // 试卷列表请求
    fetchPaperList(keyword) {
      if (keyword) {
        this.loading = true;

        examPaperList({keyword}).then((res) => {
          this.paperList = res.list || [];
          this.loading = false;
        });
      }
    },
    handlePaperChange(val) {
      this.fetchPaperItemList();
    },
    //试卷题目列表
    fetchPaperItemList() {
      if (!this.paper.id) {
        return;
      }
      examPaperItemList({ paper_id: this.paper.id }).then((res) => {
        this.itemList = res.list || [];
      });
    },
    // 选择
    handleSelectionChange(val) {
      this.selections = val;
      this.diffSelection();
    },
    handleSubmit() {
      this.$emit("submit", { selections: this.countSelections });
      this.handleClose();
    },
    handleClose() {
      // 检索条件重置
      this.query = {
        subject: "",
        type: "",
        status: "",
        pageIndex: 1,
        pageSize: 10,
        isPaging: 1,
      };
      this.$emit("close");
    },
    // 选中项差异化计算
    diffSelection() {
      let diffs = [];
      // 减
      this.countSelections.forEach((item, index) => {
        if (!this.selections.find((v) => v.id === item.id)) {
          if (this.itemList.find((v2) => v2.id === item.id)) {
            diffs.push(item);
          }
        }
      });
      if (diffs.length) {
        this.countSelections = this.countSelections.filter((item) => !diffs.find((v) => v.id === item.id))
      }
      // 加
      this.selections.forEach((item) => {
        if (!this.countSelections.find((v) => v.id === item.id)) {
          this.countSelections.push(item);
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.dialog-wrap {
  .search-wrap {
    margin-bottom: -10px;
  }
  .result {
    margin-top: 10px;

    .material{
      max-height: 40px;
      overflow: hidden;
      overflow-y: auto;
    }
  }
  .footer {
    margin-top: 10px;
  }
}
</style>
